import React from 'react';
import { Button } from '@walmart-web/livingdesign-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import StatusCard from '../../../../components/StatusCard/index.tsx';
import useModal from '../../../../hooks/useModal.ts';
import SupportInProgressModal from './SupportInProgressModal/index.tsx';
import ProductNotReceivedModal from './ProductNotReceivedModal/index.tsx';
import { useAppDispatch } from '../../../../redux/hooks.ts';
import { ihutActions } from '../../../../redux/slices/ihut.ts';
import useSnackbar from '../../../../hooks/useSnackbar.ts';
import { logger } from '../../../../utils/logger.js';
import { Snackbar } from '@material-ui/core';
import { AUTO_HIDE_DURATION } from '../../../../constants/common.js';

type Props = {
  status: string;
};

const ProductSupportCard: React.FC<Props> = ({ status }) => {
  const { snackbarState, openSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation('ihut');
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { isOpen, openModal, closeModal } = useModal();
  const {
    isOpen: isProductNotReceivedModalOpen,
    openModal: openProductNotReceivedModal,
    closeModal: closeProductNotReceivedModal
  } = useModal();

  const handleCloseProductNotReceivedModal = () => {
    closeProductNotReceivedModal();
    history.push('/activities');
  };

  const handleSupportSubmit = (isProductReceived: boolean) => {
    logger.clickStream('support_in_progress_submit_click', {
      panelistId: localStorage.getItem('panelistId') || '',
      isProductReceived: String(isProductReceived)
    });

    if (!isProductReceived) {
      dispatch(ihutActions.updatePanelistState({ disqualifyPanelist: true }))
        .unwrap()
        .then(() => {
          closeModal();
          openProductNotReceivedModal();
        })
        .catch((err) => {
          logger.error(
            'Error updating ihut panelist state to testing completed',
            err
          );
          openSnackbar(
            err?.message || t('somethingWentWrong', { ns: 'common' })
          );
        });
      return;
    }

    dispatch(ihutActions.setDeliveryConfirmed());
    closeModal();
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        message={snackbarState.message}
        autoHideDuration={AUTO_HIDE_DURATION}
        onClose={closeSnackbar}
      />
      <StatusCard
        status={status}
        imgSrc="/assets/images/ihut/survey-support.png"
        showTag
        tagProps={{
          variant: 'tertiary',
          color: 'spark',
          text: t('deliveryStatus.inProgress')
        }}
      >
        <StatusCard.Heading>{t('support.inProgress')}</StatusCard.Heading>
        <StatusCard.Text>{t('support.weAreWorking')}</StatusCard.Text>
        <StatusCard.Row>
          <Button variant="secondary" size="small" onClick={openModal}>
            {t('viewDetails', { ns: 'common' })}
          </Button>
        </StatusCard.Row>
      </StatusCard>
      <SupportInProgressModal
        isOpen={isOpen}
        handleClose={closeModal}
        handleSubmit={handleSupportSubmit}
      />
      <ProductNotReceivedModal
        isOpen={isProductNotReceivedModalOpen}
        handleClose={handleCloseProductNotReceivedModal}
      />
    </>
  );
};

export default ProductSupportCard;
